import { defineMessages } from 'react-intl';

export default defineMessages({
  label: {
    id: 'booking.price.label',
    defaultMessage: 'Total (USD)',
  },
});
